import { Utils } from 'kryfe-lib';
import { message } from 'antd';

import API from '../api';
import * as actionTypes from '../consts/actionTypes';
import { getCity, commitInfo } from './banner';
import { isBUI } from 'shared/utils/commonUtil';

const { customTimestampMeta } = Utils.customActionUtil;

function saveInfo(data = {}) {
  let api;
  if (isBUI()) {
    api = API.saveInfoBUI;
  } else {
    api = API.saveInfo;
  }

  return dispatch => {
    return dispatch({
      type: actionTypes.SAVE_INFO,
      payload: api(data),
      meta: customTimestampMeta({
        handlers: {
          failed: (dispatch, getState, { message }) => {
            message.error(message);
          },
        },
      }),
    });
  };
}

// 点击计算额度保存用户信息
function judgeLimit(data) {
  return dispatch => {
    return dispatch({
      type: actionTypes.JUDGELIMIT,
      payload: API.judgeLimit(data),
      // 调用timestampMeta，支持处理同一个请求的先后顺序问题
      meta: customTimestampMeta({
        handlers: {
          success: (dispatch, getState, { body }) => {
            // 接口成功回调或者toast提示（如果需要）
          },
          failed: (dispatch, getState, { message }) => {
            message.error(message);
            // 接口失败回调或者toast提示（如果需要）
          },
          finally: () => {
            // console.log('finally');
            // success/failed 执行结束之后执行
          },
        },
      }),
    });
  };
}

// 点击计算额度保存用户信息
function judgeLimitPhone(data, success) {
  return dispatch => {
    return dispatch({
      type: actionTypes.JUDGELIMIT,
      payload: API.judgeLimit(data),
      // 调用timestampMeta，支持处理同一个请求的先后顺序问题
      meta: customTimestampMeta({
        handlers: {
          success: (dispatch, getState, { body }) => {
            // 接口成功回调或者toast提示（如果需要）
            message.success('申请成功');
            if (_.isFunction(success)) {
              success();
            }
          },
          failed: (dispatch, getState, { message }) => {
            message.error(message);
            // 接口失败回调或者toast提示（如果需要）
          },
          finally: () => {
            // console.log('finally');
            // success/failed 执行结束之后执行
          },
        },
      }),
    });
  };
}

export { getCity, commitInfo, saveInfo, judgeLimit, judgeLimitPhone };



// WEBPACK FOOTER //
// ./src/pages/newHome/actions/index.js